import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { dynamicTranslate, translate } from 'components/Translation';
import moment from 'moment';
import numeral from 'numeral';
import { now } from 'utils/date/getDate';
import _ from 'lodash';
import { exportToXLS } from 'utils/export/export';
import AccountFilterTable from 'views/common/AccountFilterTable';
import { AccountCell, LinkCell, TextCell } from 'components/Cells/Cells';
import PDF from 'assets/img/pdf.svg';
import { AccountsService } from 'services/accounts/accounts';
import { BillsService } from 'services/bills/bills';
import { hideLoadingIndicator, showLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { useDispatch } from 'react-redux';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billsStyle';
import { makeStyles } from '@material-ui/styles';
import { BodyM, BodyMBold, HeadingMBold } from 'components/Typography/Typography';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import { IBillData, IInvoice } from 'utils/api/models/bills/billsHistoryForAccount';
import { useHistory, useLocation } from 'react-router';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Button from 'components/CustomButtons/Button';
import PaySelected from './subcomponents/PaySelected';
import PaymentConfirmedDialog from '../common/PaymentConfirmedDialog';
import PaymentRejectedDialog from 'views/PrepaidLoyalty/commons/PaymentRejectedDialog';
import { clearBillValue, setSelectedBills } from 'redux/modules/bills/actions';
import { IBillingAccount } from 'utils/api/models/bills/billingIds';
import CustomPopUpWithLoader from 'components/CustomPopUpWithLoader/CustomPopUpWithLoader';
import CustomTag from 'components/CustomTag/CustomTag';
import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import { BillingRequest } from 'utils/api/models/bills/bills';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import { hasPermission } from 'utils/permissions/permissions';
import { upIdSelector, userTypeSelector } from 'redux/modules/session/selectors';
import { useSelector } from 'react-redux';
import DownloadZipDialog from './subcomponents/DownloadZipDialog';
import { getBOMLabels } from 'redux/modules/dynamicLabels/selectors';
import {
	ACC_TYPE,
	ALL,
	BILLING_TYPE,
	CLOSED,
	DEFAULT_QUANTITY,
	OPEN,
	PAID,
	PAYMENT_TYPE,
	PENDING,
	STEPS,
} from '../constants';
import FilterHeaders from './subcomponents/Filters/FilterHeaders';
import { setDataLayer } from 'commons/gtm/dataLayerWrapper';
import { getLanguage } from 'utils/language/language';
import { BillItem } from 'components/PaymentMethod';
import { MY_BILLS_PAY } from 'components/PaymentMethod/constant';
import { SingleBillId } from 'utils/api/models/bills/singleBillId';
import { selectedBillsValueSelector } from 'redux/modules/bills/selectors';
import { roundup } from 'components/PaymentMethod/helper/number';
import { getCommonLabels } from '../../../redux/modules/dynamicLabels/selectors';
import { setFilters } from 'redux/modules/numbers/actions';
import { filtersSelector } from 'redux/modules/numbers/selectors';
import useNewTheme from 'commons/hooks/newtheme/useNewTheme';

// @ts-ignore
const useStyles = makeStyles(styles);

const useQuery = () => {
	return new URLSearchParams(useLocation().search);
};

interface ISelectedAccount {
	name: string;
	id: string | null;
}

export type dialogType = 'success' | 'failier' | null;

interface IBillsList {
	setPaymentData: Function;
	setActiveTab: Function;
}

const BillsList = ({ setActiveTab, setPaymentData }: IBillsList) => {
	const [searchValue, setSearchValue] = useState('');
	const [selected, setSelected] = useState<number[]>([]);
	const [accounts, setAccounts] = useState<Array<SingleCorpAccount>>([]);
	const [selectedAccount, setSelectedAccount] = useState<ISelectedAccount | null>(null);
	const labels = useSelector(getBOMLabels);
	const commonLabels = useSelector(getCommonLabels);
	const billsListLabels = labels?.billsListLabels || {};
	const [appliedFilters, setAppliedFilters] = useState<types.redux.numbers.MyBillsFilters>({
		organization: '',
		billingId: '',
		billingPeriod: {
			startDate: moment(now).subtract(billsListLabels.billsSearchingLimit, 'months'),
			endDate: moment().endOf('day'),
			period: '',
		},
		billingStatus: {
			value: 'all',
			id: '1',
			name: labels.bomStatusLabels.All,
		},
	});

	const [loadingInvoices, setLoadingInvoices] = useState(false);
	const [loadingAccounts, setLoadingAccounts] = useState(true);
	const [showPaySelectedDialog, setShowPaySelectedDialog] = useState<boolean>(false);
	const [showPaySelected, setShowPaySelected] = useState<boolean>(false);
	const [invoices, setInvoices] = useState<types.bills.IExtendedInvoice[]>([]);
	const [billingAccounts, setBillingAccounts] = useState<IBillingAccount[]>([]);
	const [billPeriod, setBillPeriod] = useState<number | string>(1);
	const [filteredInvoices, setFilteredInvoices] = useState<types.bills.IExtendedInvoice[]>([]);
	const [unpaidInvoices, setUnpaidInvoices] = useState<types.bills.IExtendedInvoice[]>([]);
	const [showResultDialog, setResultDialog] = useState<dialogType>();
	const dispatch = useDispatch();
	const isNewHeaderVisible = useNewTheme();
	const classes = useStyles({ isNewHeaderVisible });
	const history = useHistory();
	const query = useQuery();

	const selectedDialogType = query.get('payment') as dialogType;
	const [selectedBillingAccountId, setSelectedBillingAccountId] = useState<string[]>([]);
	const [billingRequest, setBillingRequest] = useState<BillingRequest[]>([]);
	const [billingRequestSuccessDialog, setBillingRequestSuccessDialog] = useState<boolean>(false);
	const [selectedBillingId, setSelectedBillingId] = useState({ name: '', id: '' });
	const [billingIds, setBillingIds] = useState<SingleBillId[]>([]);

	const invoicesForBillingId = useMemo(() => {
		return filteredInvoices.filter((invoice) => selectedBillingAccountId?.some((sba) => invoice.billingId === sba));
	}, [selectedBillingAccountId, filteredInvoices]);
	const payableInvoices = invoicesForBillingId
		.map((singleData: any, index: number) => {
			if (singleData.invoiceStatus == OPEN) return index;
		})
		.filter((element) => element !== undefined);
	const [isDownloadZipDialogOpen, setIsDownloadZipDialogOpen] = useState<boolean>(false);
	const userType = useSelector(userTypeSelector);
	const accId = useSelector(upIdSelector);
	const selectedBills = useSelector(selectedBillsValueSelector);
	const billsFilters = useSelector(filtersSelector);

	const hidePaymentDialog = () => {
		dispatch(clearBillValue());
		setResultDialog(null);
		history.push('/dashboard/payments/bills');
	};
	const getBillingRequest = useCallback(() => {
		BillsService.getBillingRequest()
			.pipe(finalize(() => dispatch(hideLoadingIndicator())))
			.subscribe((response: any) => {
				setBillingRequest(response?.response);
			});
	}, [dispatch]);

	const showDownloadZipDialog = () => {
		setIsDownloadZipDialogOpen(true);
	};

	const exportToXls = () => {
		const source =
			selectedBills.length === 0
				? filteredInvoices
				: selectedBills.map((index: string | number) => filteredInvoices[index]);
		const data = source.map((invoice: any) => ({
			Date: moment(invoice.invoiceDate).format('DD.MM.YYYY'),
			'Bill no': invoice.invoiceNo,
			'Organization name': invoice.account ? invoice.account.accountName : '',
			'Account number': invoice.billingId,
			'Total due': numeral(invoice.invoiceAmount).format('0,0[.]000'),
			'Payments status': getStatus(invoice),
		}));

		exportToXLS(data, `bills ${moment().format('LLL')}`);
	};

	useEffect(() => {
		if (selectedDialogType) {
			setResultDialog(selectedDialogType);
		}
	}, [selectedDialogType]);

	useEffect(() => {
		AccountsService.getCorpAccountsForCurrentUser()
			.pipe(finalize(() => setLoadingAccounts(false)))
			.subscribe(
				({ accounts }) => {
					setAccounts(accounts);
					setSelectedAccount({
						name: accounts[0].accountName,
						id: accounts[0].accountId,
					});
				},
				(error) => throwError(error)
			);
		if (hasPermission(userType, 'user-bills:download-request')) {
			getBillingRequest();
		}
	}, [dispatch, getBillingRequest, userType]);
	const filteredBillingAccounts = useMemo(() => {
		if (selectedAccount) {
			return billingAccounts.filter((billingAccount) => billingAccount.accountId === selectedAccount?.id);
		} else {
			return billingAccounts;
		}
	}, [billingAccounts, selectedAccount]);

	const selectedBillingAccount = useMemo(() => {
		return billingAccounts.filter((acc) => selectedBillingAccountId?.includes(acc.id)) || null;
	}, [billingAccounts, selectedBillingAccountId]);

	//  to fix ODF-4719
	// useEffect(() => {
	// 	if (filteredBillingAccounts.length > 0 && selectedBillingAccountId === undefined) {
	// 		setSelectedBillingAccountId([filteredBillingAccounts[0].id]);
	// 	} else if (filteredBillingAccounts.length === 0) {
	// 		setSelectedBillingAccountId([]);
	// 	}
	// }, [filteredBillingAccounts, selectedBillingAccountId, selectedBillingAccount]);
	//  to fix ODF-4719

	useEffect(() => {
		if (billsFilters?.myBills?.billingId?.length) {
			billsFilters.myBills.billingId.forEach((account: IBillingAccount) => {
				setSelectedBillingId({ name: account.name, id: account.id });
				fetchBillsHistoryForBillingId(account.id);
			});
			const selectedIDs = billsFilters.myBills.billingId?.map((account: IBillingAccount) => {
				return account.id;
			});
			setSelectedBillingAccountId(selectedIDs);
			setAppliedFilters({
				...billsFilters?.myBills,
				billingId: billsFilters?.myBills?.billingId[0].id,
			});
			setSelectedAccount(billsFilters?.myBills.organization);
		} else {
			if (filteredBillingAccounts.length > 0 && selectedBillingAccountId.length === 0) {
				setSelectedBillingAccountId([filteredBillingAccounts[0].id]);
				setSelectedBillingId({ name: filteredBillingAccounts[0].name, id: filteredBillingAccounts[0].id });
				fetchBillsHistoryForBillingId(filteredBillingAccounts[0].id);
			} else if (filteredBillingAccounts.length === 0) {
				setSelectedBillingAccountId([]);
			}
		}
	}, [filteredBillingAccounts, billsFilters]);

	useEffect(() => {
		BillsService.getCorpBillingIds().subscribe(({ billingIds }) => setBillingIds(billingIds));
	}, []);

	useEffect(() => {
		setSelected(selectedBills);
	}, [selectedBills]);

	const getAccountType = useCallback(
		(billingId: string): string => {
			const selectedBillingId = billingIds.find((singleBillingId) => singleBillingId.billingId === billingId);
			return selectedBillingId?.accountType || selectedBillingId?.firstAccountType || ACC_TYPE.MOBILE;
		},
		[billingIds]
	);

	const formatBillsHistoryResp = (billsData: any[]) => {
		if (billsData?.length > 0 && billsData[0]?.invoices && billsData[0]?.invoices?.length > 0) {
			setInvoices((oldInvoices) => {
				const extendedInvoices = _.chain(billsData)
					.map((bill: IBillData) => {
						const account = accounts.find((account) => account.accountId === bill.accountId);
						return {
							...bill,
							invoices: bill.invoices
								? bill.invoices.map((invoice) => ({
										...invoice,
										account,
										billingId: bill.billingId,
								  }))
								: [],
						};
					})
					.flatMap((bill: any) => bill.invoices)
					.value();
				return oldInvoices.concat(extendedInvoices);
			});
		}
	};
	const fetchBillsHistoryForBillingId = (accountId: string) => {
		if (accountId) {
			setLoadingInvoices(true);
			return BillsService.getBillsHistoryForAccounts({
				billingId: accountId,
				returnTotals: true,
				returnAdjustments: false,
				corpUser: true,
			})
				.pipe(finalize(() => setLoadingInvoices(false)))
				.subscribe(
					({ billsData }) => {
						// TODO: try to get the same result without lodash
						formatBillsHistoryResp(billsData);
					},
					(error) => throwError(error)
				);
		}
	};

	const fetchBillingIds = useCallback(() => {
		return BillsService.getCorpBillingIds().subscribe((response) => {
			setBillingAccounts(
				response.billingIds.map((item) => {
					return {
						name: `${item.billingAccountName} / ${item.billingId}`,
						id: item.billingId,
						accountId: item.accountId,
						billingName: item.billingAccountName,
						key: `${item.billingId}/${item.accountId}`,
						billsHistoryFetched: false,
						accountType: item.billingAccountType,
					};
				})
			);
		});
	}, []);

	useEffect(() => {
		const billingIdsSubscription = fetchBillingIds();

		return () => {
			billingIdsSubscription?.unsubscribe();
			dispatch(hideLoadingIndicator());
		};
	}, [dispatch, fetchBillingIds]);

	useEffect(() => {
		if (!loadingAccounts && !loadingInvoices) {
			dispatch(hideLoadingIndicator());
		} else {
			dispatch(showLoadingIndicator());
		}
	}, [dispatch, loadingAccounts, loadingInvoices]);

	useEffect(() => {
		setSelected([]);
		if (
			appliedFilters.billingId ||
			appliedFilters.billingStatus ||
			appliedFilters.organization ||
			searchValue !== ''
		) {
			dispatch(setSelectedBills([]));
		}
	}, [filteredInvoices]);

	const getInteractiveOrPdfBill = (bill: types.bills.IExtendedInvoice, attachmentType: 'PDF' | 'URL') => {
		dispatch(showLoadingIndicator());
		BillsService.getCustomerBills({
			customerAccountId: bill.billingId,
			startDate: moment(bill.invoiceDate)
				.add(1, 'month')
				.format('YYYY-MM-DD'),
			attachmentType: attachmentType,
		})
			.pipe(finalize(() => dispatch(hideLoadingIndicator())))
			.subscribe((response) => {
				let href;

				if (response.type === 'PDF') {
					href = `data:application/pdf;base64,${response.data}`;
				} else {
					href = response.data;
				}

				const link = document.createElement('a');
				link.href = href;
				link.download = `${bill.billingId} ${bill.invoiceDate}`;
				link.click();
			});
	};

	const getStatus = (invoice: IInvoice) => {
		if (invoice.invoiceStatus === PENDING) return billsListLabels.pending;
		return invoice.invoiceStatus === CLOSED ? billsListLabels.paid : billsListLabels.unpaid;
	};

	const getBillingStatusColor = (invoice: IInvoice) => {
		if (invoice.invoiceStatus === PENDING) return 'danger';
		return invoice.invoiceStatus === CLOSED ? 'success-light' : undefined;
	};

	const paySelected = useCallback(() => {
		const paymentData: BillItem[] = [];
		if (filteredInvoices) {
			const unpaidInvoices = selectedBills
				.map((index: string | number) => filteredInvoices[index])
				.filter(({ invoiceStatus }: any) => invoiceStatus !== CLOSED);
			filteredBillingAccounts.forEach((bAcc) => {
				return unpaidInvoices.map((invoice: any) => {
					if (invoice.billingId === bAcc.id) {
						const paymentItem: BillItem = {
							accountId: bAcc.id, //billing id
							accountType: getAccountType(bAcc.id),
							billingType: BILLING_TYPE,
							code: invoice.invoiceNo,
							name: null,
							quantity: DEFAULT_QUANTITY,
							unitPrice: invoice.balanceDue,
							type: PAYMENT_TYPE,
							month: invoice.invoiceDate,
						};
						paymentData.push(paymentItem);
					}
				});
			});
			setDataLayer(MY_BILLS_PAY, getLanguage(), 'My Bills', accId, null, {
				stepNo: '1',
			});
			setPaymentData(paymentData);
			setActiveTab(STEPS.PAYMENT_METHOD);
			dispatch(
				setFilters({
					type: 'myBills',
					value: { ...appliedFilters, billingId: selectedBillingAccount, organization: selectedAccount },
				})
			);
		}
	}, [selected, filteredInvoices]);
	const removeBillFromList = (bill: any) => {
		const billSelectedIndex = filteredInvoices.findIndex((invoice) => invoice.invoiceNo === bill.invoiceNo);
		setSelected((oldSelected) => oldSelected.filter((ind) => ind !== billSelectedIndex));
		setUnpaidInvoices((oldInvoices) => oldInvoices.filter(({ invoiceNo }) => invoiceNo !== bill.invoiceNo));
	};
	const handleElementsSelected = (acc: IBillingAccount | any) => {
		let selectedIds: string[] = [];
		if (acc) {
			if (selectedBillingAccountId.includes(acc.id)) {
				selectedIds = selectedBillingAccountId.filter((sbaid) => sbaid !== acc.id);
				setSelectedBillingAccountId(selectedIds);
				setInvoices((oldInvoices) =>
					oldInvoices.filter((invoice) => {
						return selectedIds.includes(invoice.billingId);
					})
				);
			} else {
				selectedIds = [...selectedBillingAccountId, acc?.id];

				setLoadingInvoices(true);

				fetchBillsHistoryForBillingId(acc?.id);
				setSelectedBillingAccountId(selectedIds);
			}
		} else {
			setInvoices([]);
			setSelectedBillingAccountId([]);
		}
		const selectedId = billingAccountIds.find((bId) => bId.id === selectedIds[selectedIds.length - 1]) || {
			name: '',
			id: '',
		};
		setSelectedBillingId({
			name: selectedId.name,
			id: selectedId.id,
		});
	};

	const removeElementFromFilter = (id: string) => {
		setSelectedBillingAccountId((selectedBillingAccountId) =>
			selectedBillingAccountId.filter((sbaId) => sbaId !== id)
		);
		const account = { id: id };
		handleElementsSelected(account);
	};

	const getTagsArray = () => {
		const currentTagsArray = selectedBillingAccountId;
		if (Array.isArray(currentTagsArray)) {
			return currentTagsArray.map(
				(tag: string, index): React.ReactElement => {
					const currentTag = tag;
					if (!currentTag) {
						return <></>;
					}
					return (
						<CustomTag
							key={index}
							onClick={() => removeElementFromFilter(tag)}
							label={currentTag}
							className={classes.filterTags}
						/>
					);
				}
			);
		} else {
			return <></>;
		}
	};

	const hideDownloadZipDialog = () => {
		setIsDownloadZipDialogOpen(false);
	};

	const availableAccounts = accounts.length === 1 ? accounts : [...accounts];

	const billingAccountIds = React.useMemo(() => {
		const bAccounts = filteredBillingAccounts.map((account) => ({
			name: account.name,
			id: account.id,
		}));
		return [...bAccounts];
	}, [filteredBillingAccounts]);

	useEffect(() => {
		setFilteredInvoices(() => {
			let filteredInvoices = [...invoices];
			if (selectedAccount && selectedAccount.id !== null) {
				filteredInvoices = filteredInvoices.filter(
					({ account }) => account && account.accountId === selectedAccount.id
				);
			}
			if (appliedFilters.billingStatus) {
				filteredInvoices = filteredInvoices.filter((invoice) => {
					const paid = invoice.invoiceStatus === CLOSED;
					const unPaid = invoice.invoiceStatus === OPEN;
					const pedning = invoice.invoiceStatus === PENDING;

					if (appliedFilters.billingStatus.value.toLowerCase() === ALL) {
						return paid || unPaid || pedning;
					}
					if (appliedFilters.billingStatus.value.toLowerCase() === PENDING) {
						return pedning;
					}
					return appliedFilters.billingStatus.value.toLowerCase() == PAID ? paid : unPaid;
				});
			}

			if (appliedFilters.billingPeriod.period) {
				const [start, end] = [
					moment(appliedFilters.billingPeriod.period).startOf('month'),
					moment(appliedFilters.billingPeriod.period).endOf('month'),
				];
				filteredInvoices = filteredInvoices.filter((invoice) => {
					return (
						moment(invoice.invoiceDate).isSameOrAfter(start, 'day') &&
						moment(invoice.invoiceDate).isSameOrBefore(end, 'day')
					);
				});
			} else if (appliedFilters.billingPeriod.startDate) {
				filteredInvoices = filteredInvoices.filter((invoice) => {
					return (
						moment(invoice.invoiceDate).isSameOrAfter(appliedFilters.billingPeriod.startDate, 'day') &&
						moment(invoice.invoiceDate).isSameOrBefore(appliedFilters.billingPeriod.endDate, 'day')
					);
				});
			}
			return filteredInvoices;
		});
	}, [appliedFilters, selectedAccount, invoices, searchValue, billPeriod]);

	const clearAllTags = () => {
		setSelectedBillingAccountId([]);
		setInvoices([]);
	};

	const displayTags = () => (
		<ConditionalRender show={selectedBillingAccountId.length > 0}>
			<div className={classes.filterTagsWrapper}>
				{/* @ts-ignore */}
				{getTagsArray()}
			</div>

			<div
				onClick={() => {
					clearAllTags();
				}}
				className={classes.clearTag}
			>
				<BodyM customClassName={classes.clearAll}>{billsListLabels.clearSelection}</BodyM>
			</div>
		</ConditionalRender>
	);

	const getPayableAmount = () => {
		let amount = 0;
		let selectedInvoicesAmountArray = [];
		const selectedArray = [...selectedBills]?.sort();
		selectedInvoicesAmountArray = selectedArray.map((id: number) => invoicesForBillingId[id]?.balanceDue);
		const totalAmount = selectedInvoicesAmountArray.reduce(
			(accumulator: number, current: number) => accumulator + parseFloat(current?.toString()),
			amount
		);
		return roundup(totalAmount);
	};

	const getPayText = () => {
		if (selectedBills.length) {
			return `${dynamicTranslate(billsListLabels.totalAmount, getPayableAmount())}`;
		} else return `${billsListLabels.paymentText}`;
	};
	return (
		<div className={classes.wrapper} id="bills-list">
			<div className={classes.headerWrapper}>
				<HeadingMBold color="secondary-light" disableMargin data-testId="bills-list">
					{translate('payments.bills.header')}
				</HeadingMBold>
				<Button color="secondary-light" onClick={showDownloadZipDialog} className={classes.downloadButton}>
					{translate('payments.bills.download.request')}
				</Button>
			</div>
			<FilterHeaders
				setSelectedAccount={setSelectedAccount}
				selectedAccount={selectedAccount}
				availableAccounts={availableAccounts}
				setAppliedFilters={setAppliedFilters}
				appliedFilters={appliedFilters}
				clearAllTags={clearAllTags}
				selectedBillingId={selectedBillingId}
				handleElementsSelected={handleElementsSelected}
				billingAccountIds={billingAccountIds}
				selectedBillingAccountId={selectedBillingAccountId}
			/>
			{selectedBillingAccountId.length === 0 && (
				<BodyM customClassName={classes.accountNumberWarningMsg}>
					{labels.billsListLabels.billingAccNoWarn}
				</BodyM>
			)}
			{displayTags()}
			{/* <ConditionalRender
				show={showPaySelected}
				onTrue={() => (
					<PaymentSelected
						unpaidInvoices={unpaidInvoices}
						backFromPayment={() => setShowPaySelected(false)}
					/>
				)}
				onFalse={() => ( */}
			<AccountFilterTable
				defaultPageSize={5}
				showPaginationBottom={true}
				showPaginationTop={false}
				searchPlaceHolder={commonLabels.search}
				hideOrgFilter={true}
				accounts={accounts}
				data={invoicesForBillingId}
				setAccount={() => {}}
				selectedAccount={selectedAccount}
				filters={[]}
				onFilterChange={() => {}}
				enabledCheckoxes={payableInvoices}
				onSelect={(value) => {
					const valueArr = Array(value);
					const selectedValues: number[] = [];
					invoicesForBillingId.forEach((singleData: any, index) => {
						//@ts-ignore
						if (singleData.invoiceStatus == OPEN && valueArr[0].includes(index)) {
							selectedValues.push(index);
						}
					});
					setSelected(selectedValues);
					dispatch(
						setSelectedBills({
							selectedBills: selectedValues,
						})
					);
				}}
				selectPanel={{}}
				selected={selectedBills}
				alignColumnsCenter={[7, 8, 9]}
				columns={[
					{
						Header: translate('payments.bills.date'),
						accessor: 'invoiceDate',
						minWidth: 80,
						sortable: !loadingInvoices,
						Cell: ({ original }: any) => (
							<TextCell text={moment(original.invoiceDate).format('MMM YYYY')} />
						),
					},
					{
						Header: translate('payments.bills.number'),
						accessor: 'invoiceNo',
						minWidth: 80,
						sortable: !loadingInvoices,
						Cell: ({ original }: any) => <TextCell bold text={original.invoiceNo} color="primary-light" />,
					},
					{
						Header: translate('payments.bills.organizationName'),
						accessor: 'account.accountName',
						minWidth: 120,
						sortable: !loadingInvoices,
						Cell: ({ original }: any) => (
							<AccountCell text={original.account && original.account.accountName} />
						),
					},
					{
						Header: translate('payments.bills.accountNumber'),
						accessor: 'billingId',
						minWidth: 100,
						sortable: !loadingInvoices,
						Cell: ({ original }: any) => (
							<LinkCell
								path={`/dashboard/active-services/${original.billingId}/${original.account.accountId}`}
								text={original.billingId}
								props={{ underline: true }}
							/>
						),
					},
					{
						Header: translate('payments.bills.totalDue'),
						accessor: 'invoiceAmount',
						minWidth: 80,
						sortable: !loadingInvoices,
						Cell: ({ original }: any) => {
							const alreadyPaid = original.totalAmount - original.balanceDue;
							const balanceDueFormatted = roundup(original.balanceDue);
							const alreadyPaidFormatted = roundup(alreadyPaid);
							return (
								<div className={classes.totalDueCell}>
									<BodyM inline disableMargin>
										{translate('price', balanceDueFormatted)}
									</BodyM>
									<ConditionalRender
										show={alreadyPaid > 0}
										onTrue={() => (
											<div className={classes.totalDueTooltipWrapper}>
												<CustomTooltip placement="top" size="sm">
													{translate('bills.list.total.due.tooltip', alreadyPaidFormatted)}
												</CustomTooltip>
											</div>
										)}
									/>
								</div>
							);
						},
					},
					{
						Header: billsListLabels.status,
						accessor: 'paySingleBill',
						minWidth: 70,
						Cell: ({ original }: { original: types.bills.IExtendedInvoice | any }) => {
							return (
								<div className={classes.paymentStatusWrapper}>
									<TextCell text={getStatus(original)} color={getBillingStatusColor(original)} bold />
								</div>
							);
						},
					},
					{
						Header: <div className={classes.pdfHeader}>{translate('payments.bills.PDF')}</div>,
						id: 'documents',
						minWidth: 100,
						sortable: false,
						Cell: ({ original }: any) => (
							<div className={classes.document}>
								<img src={PDF} alt="pdf" onClick={() => getInteractiveOrPdfBill(original, 'PDF')} />
							</div>
						),
					},
				]}
				setSearchInputValue={(value) => setSearchValue(value)}
				searchInputValue={searchValue}
				loading={loadingAccounts}
				exportToXLS={exportToXls}
				withBackground
			/>
			{/* )}
			/> */}
			<>
				<div className={classes.payBill}>
					<div className={classes.amountSection}>
						<BodyMBold customClassName={selectedBills.length ? classes.blueText : ''}>
							{getPayText()}
						</BodyMBold>
					</div>
					<div className={classes.selectedBillsCount}>
						<ConditionalRender
							show={selectedBills.length > 0}
							onTrue={() => (
								<BodyM>{dynamicTranslate(billsListLabels.selectedBills, selectedBills.length)}</BodyM>
							)}
						/>
					</div>

					<div className={classes.payButtonWrapper}>
						<Button
							color="primary-dark"
							size="sm"
							onClick={paySelected}
							className={classes.payButton}
							disabled={
								!(
									selectedBills.length &&
									getPayableAmount() &&
									hasPermission(userType, 'user-bills:pay-bills')
								)
							}
						>
							{billsListLabels.pay}
						</Button>
					</div>
				</div>
			</>
			<CustomPopUpWithLoader
				isOpen={loadingInvoices}
				loading={true}
				header={['']}
				body={''}
				isError={false}
				hideDialog={() => {}}
			/>
			<ConditionalRender
				show={unpaidInvoices.length > 0}
				onTrue={() => (
					<PaySelected
						isOpen={showPaySelectedDialog}
						hideDialog={() => setShowPaySelectedDialog(false)}
						unpaidInvoices={unpaidInvoices}
						payAction={() => {
							setShowPaySelectedDialog(false);
							setShowPaySelected(true);
						}}
						removeBillFromList={removeBillFromList}
					/>
				)}
			/>
			<PaymentConfirmedDialog isOpen={showResultDialog === 'success'} hideDialog={hidePaymentDialog} />
			<PaymentRejectedDialog isOpen={showResultDialog === 'failier'} hideDialog={hidePaymentDialog} />
			<ConditionalRender
				show={billingRequestSuccessDialog && !!billingRequest[0]}
				onTrue={() => (
					<CustomConfirmationDialog
						isOpen
						hideDialog={() => setBillingRequestSuccessDialog(false)}
						header={
							<BodyM>
								{translate(
									'payments.bills.download.request.success',
									moment(
										billingRequest[0].periodMonth + '-' + billingRequest[0].periodYear,
										'MM-YYYY'
									).format('MM-YYYY')
								)}
							</BodyM>
						}
					></CustomConfirmationDialog>
				)}
			/>
			<DownloadZipDialog
				isOpen={isDownloadZipDialogOpen}
				hideDialog={hideDownloadZipDialog}
				setBillingRequest={setBillingRequest}
				setBillingRequestSuccessDialog={setBillingRequestSuccessDialog}
				billingRequest={billingRequest}
			/>
		</div>
	);
};

export default BillsList;
